module.exports = __webpack_public_path__ + "static/media/out-light.58f3f366.svg";